import {getCountryRegions} from "@malwarebytes/geography-library"
import {countries} from "../../../config/geography/countries"

export const getRegions = getCountryRegions(countries)
